export default __webpack_public_path__ + "static/media/strategy.21d8c3ce.svg";